export default __webpack_public_path__ + "static/media/eolroundprofile.8e068dde.png";